import { render, staticRenderFns } from "./InsFooter.vue?vue&type=template&id=35947234&scoped=true&"
import script from "./InsFooter.vue?vue&type=script&lang=ts&"
export * from "./InsFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35947234",
  null
  
)

export default component.exports